import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {StyledProjectWarningMissingBanner} from '@/features/projects/components/project-warning-missing-banner/style'
import {ProjectExtended} from '@/features/projects/types'
import {Trans, useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {useOutletContext, generatePath} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes'
import {usePermissions} from '@/features/auth/store/store'

export const ProjectWarningMissingRenewalEvent = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const permissions = usePermissions()

    const handleNavigateToAgenda = () => {
        const hasTeam = project.team.length > 0

        // Renewal events are scheduled around the project's expiration date; fall back to
        // the start date (and finally to today) if the expiration date is missing.
        const agendaPath = generatePath(routes.AGENDA.path, {
            entity: hasTeam ? 'users' : 'patients',
            view: hasTeam ? 'day' : 'week',
            date: dayjs(project.expirationDate || project.startDate || undefined).format('DD-MM-YYYY')
        })

        const searchParams = new URLSearchParams({
            category: hasTeam ? 'team' : 'custom'
        })

        if (hasTeam) {
            searchParams.append('patientId', project.patientId)
        } else {
            searchParams.append('subjectIds', project.patientId)
        }

        window.open(`${agendaPath}?${searchParams.toString()}`, '_blank')
    }

    return (
        <StyledProjectWarningMissingBanner align="center">
            <Flexbox gap={1} align="center">
                <AlertCircleIcon />
                <Text palette="neutral" shade="950" size="textSm">
                    <Trans
                        i18nKey="projects:missing_event_content"
                        components={{b: <b />}}
                        values={{
                            event: t('agenda:access_project_renewal_processing')
                        }}
                    />
                </Text>
            </Flexbox>
            {permissions?.agenda.read && permissions?.agenda.write && (
                <Button variant="tertiary" onClick={handleNavigateToAgenda}>
                    {t('commons:add')}
                </Button>
            )}
        </StyledProjectWarningMissingBanner>
    )
}
